// Pure phase graph for the combat state machine. No React, no Three.js.
// Codex anchors: Attack (declare → defend → resolve), Intercept
// (move-without-attack → intercept → resolve), Fight (resolution).

export const PHASES = {
  IDLE: 'idle',
  DECLARED: 'declared',
  DEFENDING: 'defending',
  INTERCEPTING: 'intercepting',
  ASSIGNING: 'assigning',
  RESOLVING: 'resolving',
  DONE: 'done',
};

const TRANSITIONS = {
  [PHASES.IDLE]: [PHASES.DECLARED, PHASES.INTERCEPTING],
  // DECLARED → RESOLVING is the Shoot path: a Ranged projectile shot is an
  // activated ability, not an attack, so it has no defend window at all.
  [PHASES.DECLARED]: [PHASES.DEFENDING, PHASES.RESOLVING, PHASES.IDLE],
  [PHASES.DEFENDING]: [PHASES.ASSIGNING, PHASES.RESOLVING, PHASES.IDLE],
  [PHASES.INTERCEPTING]: [PHASES.ASSIGNING, PHASES.RESOLVING, PHASES.IDLE],
  [PHASES.ASSIGNING]: [PHASES.RESOLVING],
  [PHASES.RESOLVING]: [PHASES.DONE],
  [PHASES.DONE]: [PHASES.IDLE],
};

export function canTransition(from, to) {
  return (TRANSITIONS[from] || []).includes(to);
}
